export default __webpack_public_path__ + "upload-icon-white.svg";